define([
    'fastdom'
], function (fastdom) {
    return emptyAdvert;

    function emptyAdvert(advert) {
        fastdom.write(function () {
            window.googletag.destroySlots([advert.slot]);
            advert.node.remove();
            advert.node = advert.slot = null;
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./static/src/javascripts-legacy/projects/commercial/modules/dfp/empty-advert.js
// module id = 739
// module chunks = 0